import React from 'react';
var defaultValue = {
  superPath: '',
  subPath: '',
  params: []
};
var Context = React.createContext(defaultValue);
export default Context;